// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pos-service label[data-v-166e7879]{margin-left:10px}.pos-service[data-v-166e7879]{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:flex-start;align-items:center}", ""]);
// Exports
module.exports = exports;
